import Rcslider from './components/Rcslider';
import { Button } from 'antd';
import { useContext } from 'react'
import { AIEditContext } from '../../AIEditContext';
import styles from './index.module.scss'
import applyBadge from '@assets/images/subscript/5.png';

const AIBeauty = (props) => {
    const { initialized, nFace, AIEditLoading } = useContext(AIEditContext)
    return (
        <div className={styles.AIBeauty}>
            <div className={`${styles.AIBeautyContent} ${!props.url && styles.disabled}`}>
                <Button
                    disabled={!initialized}
                    className={styles.SectionButton}
                    onClick={props.oneClickBodyBeauty}
                >
                    一键美体
                </Button>
                <div className={styles.BeautySection}>
                    {props.bodyArray?.map(item => (
                        <Rcslider
                            disabled={!initialized}
                            key={item.name}
                            value={item.value}
                            getRcsliderValue={(value) => {
                                props.saveUndoList();
                                item.onChange(value)
                            }}
                            title={item.label}
                            min={-100}
                            max={100}
                        />
                    ))}
                </div>
                <Button
                    disabled={!initialized || nFace == 0}
                    className={`${styles.SectionButton} ${styles.FaceButton}`}
                    onClick={props.oneClickFaceBeauty}
                >
                    一键美颜
                </Button>
                <div className={styles.BeautySection}>
                    {props.faceArray?.map(item => (
                        <Rcslider
                            disabled={!initialized || nFace == 0}
                            key={item.name}
                            value={item.value}
                            getRcsliderValue={(value) => {
                                props.saveUndoList();
                                item.onChange(value)
                            }}
                            title={item.label}
                            min={-100}
                            max={100}
                        />
                    ))}
                </div>
                <Button
                    type="primary"
                    loading={AIEditLoading}
                    disabled={!initialized}
                    className={`${styles.createBtn} ${styles.createBtn2}`}
                    onClick={props.saveResult}
                >
                    <span>应用改动</span>
                    <img className={styles.ApplyBadge} src={applyBadge} alt="" />
                </Button>
            </div>
        </div>
    )
}

export default AIBeauty;
